import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ModalContainerRequest } from './modal-container.model';

@Injectable({ providedIn: 'root' })
export class ModalContainerService {
  private readonly activeModalSubject = new BehaviorSubject<ModalContainerRequest | null>(null);
  readonly activeModal$ = this.activeModalSubject.asObservable();

  open(request: ModalContainerRequest): void {
    this.activeModalSubject.next(request);
  }

  close(): void {
    this.activeModalSubject.next(null);
  }
}
